<script setup>
import {defineProps, onMounted, reactive} from 'vue'
import mitt from "mitt";
import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import Loader from "./Loader.vue";

const emitter = mitt()

const { clientZoneTranslations } = window

const $toast = useToast();

// init reactive state
const state = reactive({
    title: window.clientZoneModalTitle ?? 'údaje',
    textareaRequired: false,
    textareaValue: '',
    loading: false,
})

function setLoaderState(value) {
  state.loading = value
}

const submitForm = (e) => {
  e.preventDefault()

  setLoaderState(true)

  state.textareaRequired = true;

  const button = e.target
  const form = button.closest('form')
  const modal = form.closest('.c-modal')
  const closeButton = modal.querySelector('button.close')

  const type = form.querySelector('input[name="type"]').value
  const textData = state.textareaValue

  if (textData === '') {
    setLoaderState(false)
    return
  }

  const data = {
    textData,
    type
  }

  axios.post('/client-zone/submit-form', data)
      .then((response) => {
        setLoaderState(false)
        if (response.data.form_status && response.data.form_status == 'success') {
          closeButton.click()
          if (response.data.message) {
            $toast.success(response.data.message)
          }
        }
      })
      .catch((error) => {
        console.log(error)
        setLoaderState(false)
      })
}

</script>

<template>
    <Loader v-if="state.loading" />
    <h4>{{ clientZoneTranslations['Klientská zóna  - žiadosti - modálne okno (nadpis)'] }} {{ state.title }}</h4>
    <form class="data-change-request-form" action="#">
      <input type="hidden" name="type" id="type" value="data-change-request">
        <div class="input-holder">
            <label for="name">{{ clientZoneTranslations['Klientská zóna  - žiadosti - modálne okno (údaje na zmenu)'] }}</label>
          <textarea name="data" id="data" :class="{ 'required': state.textareaRequired }" v-model="state.textareaValue"></textarea>
          <small v-if="state.textareaRequired && !state.textareaValue" class="error-message bg-danger">{{ clientZoneTranslations['Klientská zóna  - žiadosti - modálne okno (údaje na zmenu - požadované)'] }}</small>
        </div>

        <div class="form-submit">
            <button type="submit" class="c-button c-button--primary" @click="submitForm">
              {{ clientZoneTranslations['Klientská zóna  - žiadosti - modálne okno (odoslať)'] }}
            </button>
        </div>
    </form>
</template>
<style>
.required {
  border: 1px solid red;
}
.error-message {
  color: red;
}
</style>
